/**
* Created by kongwm.kong on 2017/7/18.
 */
<template>
    <div class="common_header_wrap">
        <div class="layout_n">
            <div class='img_logo'><img src="../../assets/img/common/logo.png"></div>
            <div class="header_text">
                <div class="ch_txt">私募信息申报平台</div>
                <div class="eh_txt">platforms of declaration</div>
            </div>
            <div class="item_wrap">
                <ul>
                    <li :class="{'active': activeRouter==='home' }" ><router-link to="/">首页</router-link></li>
                    <li :class="{'active': activeRouter==='company' }"><router-link to="/company">公司管理</router-link></li>
                    <li :class="{'active': activeRouter==='fund' }"><router-link to="/fund">基金管理</router-link></li>
                    <li :class="{'active': activeRouter==='net' }"><router-link to="/net">净值管理</router-link></li>
                    <li :class="{'active': activeRouter==='manager' }"><router-link to="/manager">基金经理管理</router-link></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                activeObj:{
                    home: true,
                    company: false,
                    fund: false,
                    net: false,
                    manager: false
                }
            }
        },
        computed:{
            activeRouter(){
                return this.$store.state.activeRouter
            }
        },
        methods: {
            activeFalse(){
                let activeObj = this.activeObj;
                for(let i in activeObj){
                    activeObj[i] = false;
                }
            },
            getActive(){
                let href = window.location.href;
                this.activeFalse();
                if(href.indexOf('company') > -1){
                    this.activeObj.company = true;
                } else if(href.indexOf('fund') > -1){
                    this.activeObj.fund = true;
                } else  if(href.indexOf('net') > -1){
                    this.activeObj.net = true;
                } else if(href.indexOf('manager') > -1){
                    this.activeObj.manager = true;
                } else{
                    this.activeObj.home = true;
                }
            }
        },
        mounted(){
            this.getActive();
        }
    }
</script>
<style lang="scss" scoped type="text/scss">
    .common_header_wrap{
        height:80px;
        background: #fff;
        padding: 19px 0;
        .img_logo{
            display: inline-block;
            height:42px;
            border-right:1px solid $border_bfb;
            padding-right:15px;
            margin-right:15px;
            line-height: 1;
            vertical-align: text-bottom;
        }
        .header_text{
            display: inline-block;
            .ch_txt{
                font-size: 24px;
                color: $c_3c3;
                line-height: 24px;
                margin-bottom: 5px;
            }
            .eh_txt{
                font-size: 12px;
                color: $c_b7b;
                line-height: 14px;
            }
        }
        //右侧
        .item_wrap{
            float: right;
            padding-top:8px;
            ul{
                li{
                    display: inline-block;
                    padding-bottom:3px;
                    font-size: 18px;
                    a{
                        color:$c_3c3;

                    }
                    &:hover{
                        a{
                            color:$btn_408;
                        }
                    }
                    &+li{
                        margin-left:50px;
                    }
                    &.active{
                        a{
                            color:$btn_408;
                        }
                        border-bottom: 3px solid $btn_408;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue